 (function () {
    'use strict';

    angular
        .module('app')
        .directive('negateEnter', negateEnterDirective);

    negateEnterDirective.$inject = [];

    function negateEnterDirective() {
        var directive = {
            require: 'ngModel',
            link: link,
        };

        function link(scope, element, attrs, modelCtrl) {
            modelCtrl.$parsers.push(function (inputValue) {
                var transformedInput = inputValue.replace(/\n/g, '').replace(/\r/g, '');

                if (transformedInput !== inputValue) {
                  modelCtrl.$setViewValue(transformedInput);
                  modelCtrl.$render();
                }

                return transformedInput;
              });
        }

        return directive;
    }
})();